export function getHousingResult(state) {
  return state.housingResult.list.get(0);
}


// WEBPACK FOOTER //
// ./src/core/housing-result/selectors.js